import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaBox, FaPlus, FaTrash, FaEdit, FaSearch, FaHistory, FaChartLine, FaTimes, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

export default function Inventario({ sucursalId, goBack }) {
    const [insumos, setInsumos] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [showModal, setShowModal] = useState(false);
    
    // Historial
    const [selectedInsumo, setSelectedInsumo] = useState(null);
    const [historial, setHistorial] = useState([]);
    const [showHistorial, setShowHistorial] = useState(false);

    const [form, setForm] = useState({ nombre: '', cantidad: '', unidad: 'unidad' });

    useEffect(() => { fetchInventario(); }, [sucursalId]);

    const fetchInventario = async () => {
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/inventario/${sucursalId}`);
            setInsumos(res.data);
        } catch (error) { console.error(error); }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!form.nombre || !form.cantidad) {
            Swal.fire({
                icon: 'warning',
                title: 'Datos incompletos',
                text: 'Por favor completa todos los campos',
                confirmButtonColor: '#f59e0b'
            });
            return;
        }
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/inventario', {
                sucursal_id: sucursalId,
                nombre_insumo: form.nombre,
                cantidad: form.cantidad,
                unidad_medida: form.unidad
            });
            Swal.fire({
                icon: 'success',
                title: '¡Guardado!',
                text: 'Insumo agregado correctamente',
                confirmButtonColor: '#10b981'
            });
            setShowModal(false);
            setForm({ nombre: '', cantidad: '', unidad: 'unidad' });
            fetchInventario();
        } catch (error) { 
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar el insumo',
                confirmButtonColor: '#ef4444'
            });
        }
    };

    const verHistorial = async (insumo) => {
        setSelectedInsumo(insumo);
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/inventario/historial/${insumo.id}`);
            setHistorial(res.data);
            setShowHistorial(true);
        } catch (error) { console.error(error); }
    };

    const handleDelete = async (id, nombre) => {
        const result = await Swal.fire({
            title: '¿Eliminar insumo?',
            text: `Se eliminará "${nombre}" del inventario`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        
        if (result.isConfirmed) {
            try {
                await axios.delete(`https://api.alquilacarbolivia.com/api/inventario/${id}`);
                Swal.fire('Eliminado', 'Insumo eliminado correctamente', 'success');
                fetchInventario();
            } catch (error) {
                Swal.fire('Error', 'No se pudo eliminar', 'error');
            }
        }
    };

    const getStockStatus = (cantidad) => {
        if (cantidad <= 0) return { color: '#ef4444', bg: '#fee2e2', label: 'Sin stock', icon: <FaExclamationTriangle/> };
        if (cantidad < 10) return { color: '#f59e0b', bg: '#fef3c7', label: 'Bajo', icon: <FaExclamationTriangle/> };
        return { color: '#10b981', bg: '#d1fae5', label: 'Disponible', icon: <FaCheckCircle/> };
    };

    const filtrados = insumos.filter(i => i.nombre_insumo.toLowerCase().includes(busqueda.toLowerCase()));

    return (
        <div className="container-fluid p-0" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            {/* Header Mejorado */}
            <div style={{
                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                padding: '1.5rem 2rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
            }}>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                        <button 
                            className="btn btn-light shadow-sm" 
                            onClick={goBack}
                            style={{ 
                                borderRadius: '12px',
                                padding: '0.5rem 1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={e => e.target.style.transform = 'translateY(-2px)'}
                            onMouseLeave={e => e.target.style.transform = 'translateY(0)'}
                        >
                            <FaArrowLeft className="me-2"/> Volver
                        </button>
                        <div className="text-white">
                            <h3 className="m-0 fw-bold d-flex align-items-center gap-2">
                                <FaBox style={{ fontSize: '1.5rem' }}/> 
                                Inventario de Insumos
                            </h3>
                            <p className="m-0 opacity-75" style={{ fontSize: '0.9rem' }}>
                                Control y seguimiento de existencias
                            </p>
                        </div>
                    </div>
                    <button 
                        className="btn btn-light shadow-lg fw-bold"
                        onClick={() => setShowModal(true)}
                        style={{
                            borderRadius: '12px',
                            padding: '0.75rem 1.5rem',
                            background: 'white',
                            border: 'none',
                            color: '#f59e0b',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={e => {
                            e.target.style.transform = 'translateY(-3px)';
                            e.target.style.boxShadow = '0 10px 20px rgba(245, 158, 11, 0.3)';
                        }}
                        onMouseLeave={e => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                        }}
                    >
                        <FaPlus className="me-2"/> Nuevo Insumo
                    </button>
                </div>
            </div>

            <div className="p-4">
                {/* Barra de búsqueda mejorada */}
                <div className="mb-4">
                    <div style={{ position: 'relative', maxWidth: '500px' }}>
                        <FaSearch style={{
                            position: 'absolute',
                            left: '1rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#94a3b8',
                            fontSize: '1rem'
                        }}/>
                        <input 
                            className="form-control form-control-lg" 
                            placeholder="Buscar insumo por nombre..." 
                            value={busqueda}
                            onChange={e => setBusqueda(e.target.value)}
                            style={{
                                paddingLeft: '3rem',
                                borderRadius: '12px',
                                border: '2px solid #e2e8f0',
                                fontSize: '1rem'
                            }}
                        />
                    </div>
                </div>

                {/* Estadísticas rápidas */}
                <div className="row g-3 mb-4">
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="m-0 opacity-75 small">Total Insumos</p>
                                        <h3 className="m-0 fw-bold">{insumos.length}</h3>
                                    </div>
                                    <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                                        <FaBox/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="m-0 opacity-75 small">Con Stock</p>
                                        <h3 className="m-0 fw-bold">{insumos.filter(i => i.cantidad > 0).length}</h3>
                                    </div>
                                    <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                                        <FaCheckCircle/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' }}>
                            <div className="card-body p-3 text-white">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="m-0 opacity-75 small">Stock Bajo</p>
                                        <h3 className="m-0 fw-bold">{insumos.filter(i => i.cantidad > 0 && i.cantidad < 10).length}</h3>
                                    </div>
                                    <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                                        <FaExclamationTriangle/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tabla mejorada */}
                {filtrados.length === 0 ? (
                    <div className="text-center py-5">
                        <div style={{ fontSize: '4rem', color: '#cbd5e1', marginBottom: '1rem' }}>
                            <FaBox/>
                        </div>
                        <h5 className="text-muted">
                            {busqueda ? 'No se encontraron resultados' : 'No hay insumos registrados'}
                        </h5>
                        <p className="text-muted">
                            {busqueda ? 'Intenta con otra búsqueda' : 'Comienza agregando tu primer insumo'}
                        </p>
                        {!busqueda && (
                            <button 
                                className="btn btn-primary mt-3"
                                onClick={() => setShowModal(true)}
                                style={{ borderRadius: '10px', padding: '0.75rem 2rem' }}
                            >
                                <FaPlus className="me-2"/> Agregar Insumo
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                    <tr>
                                        <th className="fw-bold text-muted" style={{ padding: '1rem' }}>INSUMO</th>
                                        <th className="fw-bold text-muted" style={{ padding: '1rem' }}>CANTIDAD</th>
                                        <th className="fw-bold text-muted" style={{ padding: '1rem' }}>UNIDAD</th>
                                        <th className="fw-bold text-muted" style={{ padding: '1rem' }}>ESTADO</th>
                                        <th className="fw-bold text-muted text-center" style={{ padding: '1rem' }}>ACCIONES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtrados.map(i => {
                                        const status = getStockStatus(i.cantidad);
                                        return (
                                            <tr 
                                                key={i.id}
                                                style={{
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f8fafc'}
                                                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                            >
                                                <td style={{ padding: '1rem' }}>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div style={{
                                                            width: '45px',
                                                            height: '45px',
                                                            borderRadius: '12px',
                                                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            color: 'white',
                                                            fontSize: '1.2rem'
                                                        }}>
                                                            <FaBox/>
                                                        </div>
                                                        <div>
                                                            <h6 className="m-0 fw-bold">{i.nombre_insumo}</h6>
                                                            <p className="m-0 text-muted small">SKU: INS-{String(i.id).padStart(4, '0')}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ padding: '1rem' }}>
                                                    <h5 className="m-0 fw-bold" style={{ color: status.color }}>
                                                        {i.cantidad}
                                                    </h5>
                                                </td>
                                                <td style={{ padding: '1rem' }}>
                                                    <span className="badge" style={{
                                                        background: '#f1f5f9',
                                                        color: '#475569',
                                                        padding: '0.5rem 1rem',
                                                        borderRadius: '8px',
                                                        fontWeight: '600',
                                                        fontSize: '0.85rem'
                                                    }}>
                                                        {i.unidad_medida}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '1rem' }}>
                                                    <span 
                                                        className="badge d-inline-flex align-items-center gap-1"
                                                        style={{
                                                            background: status.bg,
                                                            color: status.color,
                                                            padding: '0.5rem 1rem',
                                                            borderRadius: '20px',
                                                            fontWeight: '600',
                                                            fontSize: '0.85rem'
                                                        }}
                                                    >
                                                        {status.icon}
                                                        {status.label}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '1rem' }}>
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <button 
                                                            className="btn btn-sm"
                                                            onClick={() => verHistorial(i)}
                                                            style={{
                                                                background: '#dbeafe',
                                                                color: '#2563eb',
                                                                border: 'none',
                                                                borderRadius: '8px',
                                                                padding: '0.5rem 0.75rem',
                                                                transition: 'all 0.3s ease'
                                                            }}
                                                            onMouseEnter={e => {
                                                                e.target.style.background = '#2563eb';
                                                                e.target.style.color = 'white';
                                                            }}
                                                            onMouseLeave={e => {
                                                                e.target.style.background = '#dbeafe';
                                                                e.target.style.color = '#2563eb';
                                                            }}
                                                            title="Ver historial kardex"
                                                        >
                                                            <FaHistory/>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDelete(i.id, i.nombre_insumo);
                                                            }}
                                                            style={{
                                                                background: '#fee2e2',
                                                                color: '#dc2626',
                                                                border: 'none',
                                                                borderRadius: '8px',
                                                                padding: '0.5rem 0.75rem',
                                                                transition: 'all 0.3s ease'
                                                            }}
                                                            onMouseEnter={e => {
                                                                e.target.style.background = '#dc2626';
                                                                e.target.style.color = 'white';
                                                            }}
                                                            onMouseLeave={e => {
                                                                e.target.style.background = '#fee2e2';
                                                                e.target.style.color = '#dc2626';
                                                            }}
                                                            title="Eliminar insumo"
                                                        >
                                                            <FaTrash/>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal Historial Kardex - Mejorado */}
            {showHistorial && selectedInsumo && (
                <div 
                    className="modal d-block" 
                    style={{ 
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        backdropFilter: 'blur(4px)'
                    }}
                    onClick={() => setShowHistorial(false)}
                >
                    <div 
                        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                padding: '1.5rem'
                            }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h5 className="m-0 text-white fw-bold d-flex align-items-center gap-2">
                                            <FaChartLine/> Historial Kardex
                                        </h5>
                                        <p className="m-0 text-white opacity-75 mt-1">
                                            {selectedInsumo.nombre_insumo}
                                        </p>
                                    </div>
                                    <button 
                                        className="btn btn-light btn-sm"
                                        onClick={() => setShowHistorial(false)}
                                        style={{ borderRadius: '50%', width: '32px', height: '32px', padding: 0 }}
                                    >
                                        <FaTimes/>
                                    </button>
                                </div>
                            </div>
                            <div className="modal-body p-4" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                {historial.length === 0 ? (
                                    <div className="text-center py-5">
                                        <div style={{ fontSize: '3rem', color: '#cbd5e1' }}>
                                            <FaHistory/>
                                        </div>
                                        <p className="text-muted mt-3">No hay movimientos registrados</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead style={{ background: '#f8fafc', position: 'sticky', top: 0, zIndex: 10 }}>
                                                <tr>
                                                    <th className="fw-bold text-muted" style={{ padding: '1rem' }}>FECHA</th>
                                                    <th className="fw-bold text-muted" style={{ padding: '1rem' }}>MOVIMIENTO</th>
                                                    <th className="fw-bold text-muted text-center" style={{ padding: '1rem' }}>CANTIDAD</th>
                                                    <th className="fw-bold text-muted text-end" style={{ padding: '1rem' }}>COSTO</th>
                                                    <th className="fw-bold text-muted" style={{ padding: '1rem' }}>USUARIO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historial.map(h => (
                                                    <tr key={h.id}>
                                                        <td style={{ padding: '1rem' }}>
                                                            <div>
                                                                <div className="fw-semibold">
                                                                    {new Date(h.fecha).toLocaleDateString('es-BO', { 
                                                                        day: '2-digit', 
                                                                        month: 'short', 
                                                                        year: 'numeric' 
                                                                    })}
                                                                </div>
                                                                <div className="text-muted small">
                                                                    {new Date(h.fecha).toLocaleTimeString('es-BO', { 
                                                                        hour: '2-digit', 
                                                                        minute: '2-digit' 
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '1rem' }}>
                                                            <span 
                                                                className="badge"
                                                                style={{
                                                                    background: h.tipo === 'compra' ? '#d1fae5' : '#fee2e2',
                                                                    color: h.tipo === 'compra' ? '#059669' : '#dc2626',
                                                                    padding: '0.5rem 1rem',
                                                                    borderRadius: '20px',
                                                                    fontWeight: '600',
                                                                    fontSize: '0.85rem',
                                                                    textTransform: 'uppercase'
                                                                }}
                                                            >
                                                                {h.tipo}
                                                            </span>
                                                        </td>
                                                        <td className="text-center" style={{ padding: '1rem' }}>
                                                            <span 
                                                                className="fw-bold fs-5"
                                                                style={{ 
                                                                    color: h.cantidad > 0 ? '#10b981' : '#ef4444' 
                                                                }}
                                                            >
                                                                {h.cantidad > 0 ? '+' : ''}{h.cantidad}
                                                            </span>
                                                        </td>
                                                        <td className="text-end" style={{ padding: '1rem' }}>
                                                            <span className="fw-semibold">
                                                                {h.costo_total ? `Bs. ${parseFloat(h.costo_total).toFixed(2)}` : '-'}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '1rem' }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <div style={{
                                                                    width: '32px',
                                                                    height: '32px',
                                                                    borderRadius: '50%',
                                                                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '0.75rem'
                                                                }}>
                                                                    {h.usuario ? h.usuario.charAt(0).toUpperCase() : '?'}
                                                                </div>
                                                                <span className="fw-semibold">{h.usuario || 'Sistema'}</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer bg-light border-0 p-3">
                                <button 
                                    className="btn btn-primary fw-bold"
                                    onClick={() => setShowHistorial(false)}
                                    style={{
                                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        padding: '0.5rem 2rem'
                                    }}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Nuevo Insumo - Mejorado */}
            {showModal && (
                <div 
                    className="modal d-block" 
                    style={{ 
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        backdropFilter: 'blur(4px)'
                    }}
                    onClick={() => setShowModal(false)}
                >
                    <div 
                        className="modal-dialog modal-dialog-centered"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                padding: '1.5rem'
                            }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="m-0 text-white fw-bold d-flex align-items-center gap-2">
                                        <FaPlus/> Nuevo Insumo
                                    </h5>
                                    <button 
                                        className="btn btn-light btn-sm"
                                        onClick={() => setShowModal(false)}
                                        style={{ borderRadius: '50%', width: '32px', height: '32px', padding: 0 }}
                                    >
                                        <FaTimes/>
                                    </button>
                                </div>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold text-muted small">Nombre del Insumo</label>
                                        <input 
                                            className="form-control form-control-lg" 
                                            placeholder="Ej: Arroz blanco" 
                                            value={form.nombre}
                                            required
                                            onChange={e => setForm({...form, nombre: e.target.value})}
                                            style={{ borderRadius: '10px', border: '2px solid #e2e8f0' }}
                                        />
                                    </div>

                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold text-muted small">Cantidad Inicial</label>
                                            <input 
                                                type="number"
                                                step="0.01"
                                                className="form-control form-control-lg" 
                                                placeholder="0.00" 
                                                value={form.cantidad}
                                                required
                                                onChange={e => setForm({...form, cantidad: e.target.value})}
                                                style={{ borderRadius: '10px', border: '2px solid #e2e8f0' }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold text-muted small">Unidad de Medida</label>
                                            <select 
                                                className="form-select form-select-lg"
                                                value={form.unidad}
                                                onChange={e => setForm({...form, unidad: e.target.value})}
                                                style={{ borderRadius: '10px', border: '2px solid #e2e8f0' }}
                                            >
                                                <option value="unidad">Unidad</option>
                                                <option value="kg">Kilogramo (KG)</option>
                                                <option value="lt">Litro (LT)</option>
                                                <option value="g">Gramo (G)</option>
                                                <option value="ml">Mililitro (ML)</option>
                                                <option value="lb">Libra (LB)</option>
                                                <option value="oz">Onza (OZ)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="alert alert-info mt-3 d-flex align-items-start gap-2" style={{ 
                                        borderRadius: '10px',
                                        background: '#dbeafe',
                                        border: 'none',
                                        color: '#1e40af'
                                    }}>
                                        <FaBox className="mt-1"/>
                                        <small>
                                            La cantidad inicial será registrada como una compra en el historial kardex.
                                        </small>
                                    </div>
                                </div>
                                <div className="modal-footer bg-light border-0 p-3">
                                    <button 
                                        type="button" 
                                        className="btn btn-light"
                                        onClick={() => setShowModal(false)}
                                        style={{ borderRadius: '10px', padding: '0.5rem 1.5rem' }}
                                    >
                                        Cancelar
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary fw-bold"
                                        style={{
                                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                            border: 'none',
                                            borderRadius: '10px',
                                            padding: '0.5rem 2rem'
                                        }}
                                    >
                                        <FaCheckCircle className="me-2"/> Guardar Insumo
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}